/* eslint-disable */
import ol from "./ol";

function MvtImageryProvider(options) {
  // console.log('options',options);
  options = Cesium.defaultValue(options, Cesium.defaultValue.EMPTY_OBJECT)
  this.options = options

  this._tileWidth = Cesium.defaultValue(options.tileWidth, 512)
  this._tileHeight = Cesium.defaultValue(options.tileHeight, 512)
  this._minimumLevel = Cesium.defaultValue(options.minimumLevel, 0)
  this._maximumLevel = Cesium.defaultValue(options.maximumLevel, 18)

  if (options.rectangle && options.rectangle.xmin && options.rectangle.xmax && options.rectangle.ymin && options.rectangle.ymax) {
    var xmin = options.rectangle.xmin
    var xmax = options.rectangle.xmax
    var ymin = options.rectangle.ymin
    var ymax = options.rectangle.ymax
    options.rectangle = Cesium.Rectangle.fromDegrees(xmin, ymin, xmax, ymax)
  }
  this._allowPick = Cesium.defaultValue(options.enablePickFeatures, false);
  this._tilingScheme = Cesium.defaultValue(options.tilingScheme, new Cesium.WebMercatorTilingScheme({ ellipsoid: options.ellipsoid }))

  // this._tilingScheme = new Cesium.GeographicTilingScheme({ ellipsoid: options.ellipsoid });
  // console.log('tilingScheme',this._tilingScheme);
  this._rectangle = Cesium.defaultValue(options.rectangle, this._tilingScheme.rectangle)
  this._rectangle = Cesium.Rectangle.intersection(this._rectangle, this._tilingScheme.rectangle)
  // console.log('rectangle',this._rectangle);
  this._hasAlphaChannel = Cesium.defaultValue(options.hasAlphaChannel, true)

  this._featuresPicked = new Cesium.Event();
  this._errorEvent = new Cesium.Event()
  this._readyPromise = Cesium.defer()
  this._credit = undefined
  this._ready = true

  this._features = undefined

  //mvt相关的处理
  this._ol = ol
  this._mvtParser = new this._ol.format.MVT()

  this._key = Cesium.defaultValue(options.key, "")
  this._url = Cesium.defaultValue(options.url, "")

  if (options.styleConfig) {
    //(glStyle, sources, resolutions = defaultResolutions, spriteData, spriteImageUrl, getFonts)
    this._styleClass = window.olms.stylefunction(options.styleConfig, options.styleConfig.sources, "", null, null)
    // this._url = options.styleConfig.tiles[0]
  } else if (options.style) {
    switch (options.style) {
      case "mapbox-streets-v6":
        this._styleClass = new mars3d.MapboxStreetsV6()
        break
      default:
        this._styleClass = options.style
        break
    }
  }

  if(this._tilingScheme._rectangleSouthwestInMeters && this._tilingScheme._rectangleNortheastInMeters){
    var sw = this._tilingScheme._rectangleSouthwestInMeters
    var ne = this._tilingScheme._rectangleNortheastInMeters
    var mapExtent = [sw.x, sw.y, ne.x, ne.y]
    this._resolutions = ol.tilegrid.resolutionsFromExtent(mapExtent, this._maximumLevel, this._tileWidth)
  }else{
    var boundingRect = [
      Cesium.Math.toDegrees(this._rectangle.west),
      Cesium.Math.toDegrees(this._rectangle.south),
      Cesium.Math.toDegrees(this._rectangle.east),
      Cesium.Math.toDegrees(this._rectangle.north)
   ];
   this._resolutions = ol.tilegrid.resolutionsFromExtent(boundingRect, this._maximumLevel, this._tileWidth)
  }
  // console.log('resolution',this._resolutions );

  this._pixelRatio = 1
  this._transform = [0.125, 0, 0, 0.125, 0, 0]
  this._replays = ["Default", "Image", "Polygon", "LineString", "Text"]

  this._tileQueue = new Cesium.TileReplacementQueue()
  this._cacheSize = 1000
}

Object.defineProperties(MvtImageryProvider.prototype, {
  proxy: {
    get: function () {
      return undefined
    }
  },

  tileWidth: {
    get: function () {
      return this._tileWidth
    }
  },

  tileHeight: {
    get: function () {
      return this._tileHeight
    }
  },

  maximumLevel: {
    get: function () {
      return undefined
    }
  },

  minimumLevel: {
    get: function () {
      return undefined
    }
  },

  tilingScheme: {
    get: function () {
      return this._tilingScheme
    }
  },

  rectangle: {
    get: function () {
      return this._tilingScheme.rectangle
    }
  },

  tileDiscardPolicy: {
    get: function () {
      return undefined
    }
  },

  errorEvent: {
    get: function () {
      return this._errorEvent
    }
  },

  featuresPicked: {
    get: function () {
        return this._featuresPicked;
    }
  },

  ready: {
    get: function () {
      return true
    }
  },

  readyPromise: {
    get: function () {
      return this._readyPromise.promise
    }
  },

  credit: {
    get: function () {
      return undefined
    }
  },

  hasAlphaChannel: {
    get: function () {
      return true
    }
  }
})

MvtImageryProvider.prototype.getTileCredits = function (x, y, level) {
  return undefined
}

MvtImageryProvider.prototype.pickFeatures = function (x, y, level, longitude, latitude) {
  //alert(longitude+","+ latitude);
}

/**
 * 重写此函数，实现：要素被点击时准备好并返回要素查询结果信息。
 * @param {Feature}feature geojson要素
 * @param {Number}x 当前点所在tms瓦片编号x部分
 * @param {Number}y 当前点所在tms瓦片编号y部分
 * @param {Number}level 当前点所在tms瓦片级别
 * @param {Number}longitude 当前点击的点经度（单位是弧度）
 * @param {Number}latitude 当前点击的点纬度（单位是弧度）
 * @return {Promise.<Cesium.ImageryLayerFeatureInfo>|Cesium.ImageryLayerFeatureInfo}
 */
MvtImageryProvider.prototype.prepareFeatureInfo = function (feature, x, y, level, longitude, latitude) {
  return undefined;
}

MvtImageryProvider.prototype.pickFeatures = function (x, y, level, longitude, latitude,height) {
  // return undefined
  // let count = 0
  // count++
  
  // console.log('pickFeature',x, y, level,longitude,latitude,height,this.rectangle);
  var that = this;

  if (!this._allowPick) {
    that._featuresPicked.raiseEvent(that, undefined);
    return undefined;
  }
  var pt = turf.point([Cesium.Math.toDegrees(longitude), Cesium.Math.toDegrees(latitude)]);

  // console.log('queryUrl',that.options.queryUrl);
  if(that.options.queryUrl){
    mars3d.Util.fetchJson({
      // url: that.options.pickFeaturesUrl,
      url: that.options.queryUrl.includes('geoserver') ? that.options.queryUrl : that.options.queryUrl + '/' + that.options.url.split('/')[5] +'/'+ Cesium.Math.toDegrees(longitude) + '%2C' + Cesium.Math.toDegrees(latitude)+'%2C4326',
      queryParameters: {
        // access_token: that.options.key || "mars3d",
        //<Intersects> <gml:Point> 都可以修改
        filter:that.options.queryUrl.includes('geoserver') ? `<Filter xmlns="http://www.opengis.net/ogc" xmlns:gml="http://www.opengis.net/gml">  
        <Intersects>
          <PropertyName>geom</PropertyName>
          <gml:Point>   
            <gml:coordinates>${Cesium.Math.toDegrees(longitude)},${Cesium.Math.toDegrees(latitude)}</gml:coordinates> 
          </gml:Point> 	
        </Intersects>
        </Filter>
        `:''
      }
    }).then((data)=>{
      // console.log('data',data);
      if(data.features){
        that._features = data.features
      }else{
        let properties = {}
        properties.properties = data[0]
        properties.geometry = JSON.parse(data[0].geom_)
        
        let rebuildData = []
        rebuildData.push(properties)
        that._features = rebuildData
      }
      that._features[0].pointCoor = pt.geometry.coordinates
      if (that._features.length) {
        var df = {};
        df.promise = new Promise(function (resolve, reject) {
            df.resolve = resolve
            df.reject = reject
        })
  
        var startTime = new Date();
        Promise.all(that._features).then(function (pickedFeatures) {
            var timespan = new Date() - startTime;
            if (timespan < 100) {
                setTimeout(function () {
                    that._featuresPicked.raiseEvent(that, pickedFeatures);
                    df.resolve(pickedFeatures);
                }, 100);
            } else {
                that._featuresPicked.raiseEvent(that, pickedFeatures);
                df.resolve(pickedFeatures);
            }
        }).catch(function (err) {
            console.error(err);
            that._featuresPicked.raiseEvent(that, undefined);
        })
        return df.promise;
    } else {
        that._featuresPicked.raiseEvent(that, undefined);
    }
    })
  }
  // console.log('over');
}

MvtImageryProvider.prototype.requestImage = function (x, y, level, request) {
  var cacheTile = findTileInQueue(x, y, level, this._tileQueue)
  if (cacheTile != undefined) {
    return new Promise((resolve, reject) => {
      resolve(cacheTile)
    })
  } else {
    var that = this
    var url = this._url

    var reverseY = this._tilingScheme.getNumberOfYTilesAtLevel(level) - y - 1
    url = url.replace("{x}", x).replace("{y}", y).replace("{reverseY}", reverseY).replace("{z}", level).replace("{k}", this._key)

    var resource = Cesium.Resource.createIfNeeded(url)
    return resource.fetchArrayBuffer().then(function (arrayBuffer) {
      var canvas = document.createElement("canvas")
      canvas.width = that._tileWidth
      canvas.height = that._tileHeight
      var vectorContext = canvas.getContext("2d")

      var features = that._mvtParser.readFeatures(arrayBuffer)
      // console.log('features',features);

      // console.log('styleClass',that._styleClass);
      // var styleFun = that._styleClass.getStyle()
      var styleFun = that._styleClass

      var extent = [0, 0, 4096, 4096]
      var _replayGroup = new ol.render.canvas.ReplayGroup(0, extent, 8, true, 100)

      for (var i = 0; i < features.length; i++) {
        var feature = features[i]
        var styles = styleFun(features[i], that._resolutions[level])
        for (var j = 0; j < styles.length; j++) {
          ol.renderer.vector.renderFeature_(_replayGroup, feature, styles[j], 16)
        }
      }
      _replayGroup.finish()

      _replayGroup.replay(vectorContext, that._pixelRatio, that._transform, 0, {}, that._replays, true)
      if (that._tileQueue.count > that._cacheSize) {
        trimTiles(that._tileQueue, that._cacheSize / 2)
      }

      canvas.xMvt = x
      canvas.yMvt = y
      canvas.zMvt = level
      that._tileQueue.markTileRendered(canvas)

      // delete _replayGroup
      _replayGroup = null

      return canvas
    })
  }
}

function findTileInQueue(x, y, level, tileQueue) {
  var item = tileQueue.head
  while (item != undefined && !(item.xMvt == x && item.yMvt == y && item.zMvt == level)) {
    item = item.replacementNext
  }
  return item
}

function removeQueue(tileReplacementQueue, item) {
  var previous = item.replacementPrevious
  var next = item.replacementNext

  if (item === tileReplacementQueue._lastBeforeStartOfFrame) {
    tileReplacementQueue._lastBeforeStartOfFrame = next
  }

  if (item === tileReplacementQueue.head) {
    tileReplacementQueue.head = next
  } else {
    previous.replacementNext = next
  }

  if (item === tileReplacementQueue.tail) {
    tileReplacementQueue.tail = previous
  } else {
    next.replacementPrevious = previous
  }

  item.replacementPrevious = undefined
  item.replacementNext = undefined

  --tileReplacementQueue.count
}

function trimTiles(tileQueue, maximumTiles) {
  var tileToTrim = tileQueue.tail
  while (tileQueue.count > maximumTiles && Cesium.defined(tileToTrim)) {
    var previous = tileToTrim.replacementPrevious

    removeQueue(tileQueue, tileToTrim)
    // delete tileToTrim
    tileToTrim = null

    tileToTrim = previous
  }
}

class PbfolLayer extends mars3d.layer.BaseTileLayer {
  _addedHook() {
    let styleUrl = this.options.style
    if (mars3d.Util.isString(styleUrl) && styleUrl.endsWith(".json")) {
      this.getPbfStyle(styleUrl).then((data) => {
        if (this.isAdded) {
          super._addedHook()
        }
      })
    } else {
      super._addedHook()
    }
  }
  //构建ImageryProvider
  async _createImageryProvider(options) {
    return createImageryProvider(options)
  }

  //取样式数据
  getPbfStyle(styleUrl) {
    return mars3d.Util.fetchJson({
      url: styleUrl,
      queryParameters: {
        access_token: this.options.key || "mars3d"
      }
    })
      .then((json) => {
        this.options.styleConfig = json
      })
      .catch(function (error) {
        console.log("加载样式出错", error)
      })
  }
}

function createImageryProvider(options) {
  return new MvtImageryProvider(options)
}
PbfolLayer.createImageryProvider = createImageryProvider

//注册下
const layerType = "mvt" //图层类型
mars3d.LayerUtil.register(layerType, PbfolLayer)
mars3d.LayerUtil.registerImageryProvider(layerType, createImageryProvider)

mars3d.provider.MvtImageryProvider = MvtImageryProvider
mars3d.layer.PbfolLayer = PbfolLayer

//对外接口
export default PbfolLayer;
